import { graphQuery, gql } from "shared/lib/graphql"

const abandonedCheckoutMutation = gql`
  mutation abandonedCheckoutMutation($plan_id: user_tier_type) {
    userProAbandonedCheckoutEmail(input: { plan_id: $plan_id }) {
      errors {
        attribute
        message
      }
      email_scheduled
    }
  }
`

// Fire and forget - errors are not user-facing.
// Skip the GraphQL mutation entirely when there is no authenticated user — the IFE backend
// returns "Authentication failed" for logged-out callers, which floods Datadog RUM with
// noise even though the call is best-effort.
export default function scheduleAbandonedCheckoutEmail(tier) {
  if (!window.App?.user?.id) return
  graphQuery(abandonedCheckoutMutation, { plan_id: tier }).catch(() => {})
}
